module.exports = __webpack_public_path__ + "img/tom-haugomat-french-riviera.5dd07a3.jpg";